import React from "react";
import { Link } from "react-router-dom";
// eslint-disable-next-line
import { Rate } from "../timesheets";
import TimesheetStatus from "../TimesheetStatus/TimesheetStatus";
import "./DesktopTimesheets.css";
import { calculateTimesheetStatus } from "../helpers/helpers";
import OverflowedText from "../../common/OverflowedText/OverflowedText";

const DesktopTimesheets = ({
  className,
  setTimesheet,
  sortedRows,
  togglePopup,
  isDayType
}) => {
  console.log(sortedRows);
  return (
    <table className={`timesheets__table ${className}`}>
      <thead>
        <tr>
          <th className="table__column timesheets__table-header timesheets__statusField"></th>
          <th className="table__column timesheets__table-header timesheets__nameField">
            WORKER
          </th>
          <th className="table__column timesheets__table-header timesheets__nameField">
            JOB TITLE
          </th>
          <th className="table__column timesheets__table-header timesheets__nameField">
            APPROVED BY
          </th>
          <th className="table__column timesheets__table-header timesheets__rates">
            CHARGE
          </th>
          <th className="table__column timesheets__table-header timesheets__rates">
            {isDayType ? "DAYS" : "HOURS"}
          </th>
          <th className="table__column timesheets__table-header"></th>
          <th className="table__column timesheets__table-header timesheets__viewButton"></th>
        </tr>
      </thead>
      <tbody>
        {sortedRows.map(row => (
          <tr key={row.timesheetRef} className="timesheets__row">
            <td className="table__column table__column-status timesheets__statusField">
              <TimesheetStatus status={calculateTimesheetStatus(row)} />
            </td>
            <td className="table__column timesheets__nameField">
              <OverflowedText overflowedText={row.candidateName}>
                {row.candidateName}
              </OverflowedText>
            </td>
            <td className="table__column timesheets__nameField">
              <OverflowedText overflowedText={row.jobTitle}>
                {row.jobTitle}
              </OverflowedText>
            </td>
            <td className="table__column timesheets__nameField">
              {row.authorisedBy !== null && (
                <OverflowedText overflowedText={row.authorisedBy}>
                  {row.authorisedBy}
                </OverflowedText>
              )}
              {row.authorisedBy === null && "-"}
            </td>
            <Rate
              totaledInvoices={row.totalInvoiceAmount.toFixed(2)}
              totaledHours={row.rowTotaledHours}
              isDayType={isDayType}
            />
            <td className="table__column">
              <span
                className="timesheets__summaryButton"
                onClick={() => {
                  setTimesheet(row);
                  togglePopup();
                }}
              >
                {isDayType ? "" : "Summary"}
              </span>
            </td>
            <td className="table__column timesheets__viewField">
              <Link
                to={{
                  pathname: `/timesheets/${row.timesheetRef}`,
                  state: {
                    sortedTimesheetRefs: sortedRows.map(sr => sr.timesheetRef)
                  }
                }}
              >
                <button className="btn btn-primary timesheets__viewButton">
                  View timesheet
                </button>
              </Link>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default DesktopTimesheets;
